// modifer: styles/jss/nextjs-material-kit-pro/pages/componentsSections/typographyStyle.js

import { section, container, title } from 'styles/jss/original/base';

const styles = {
  section: {
    ...section,
    padding: '80px 0 40px',
    '@media (min-width: 1024px)': {
      padding: '60px 0 40px'
    },
    '@media (max-width: 992px)': {
      padding: '60px 0 30px'
    },
    '@media (max-width: 640px)': {
      padding: '40px 0 20px'
    }
  },
  container,
  title: {
    ...title,
    textAlign: 'center'
  },
  titleSub: {
    ...title,
    textAlign: 'center',
    marginTop: '15px'
  },
  titleLevel2: {
    ...title,
    fontSize: '2.25rem',
    '@media (max-width: 640px)': {
      fontSize: '1.8rem',
      marginTop: '10px'
    },
    '@media (max-width: 320px)': {
      fontSize: '1.6rem'
    }
  }
};

export default styles;
